import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from "../../../../model/guru-entity";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {ModelService} from "../../../../services/model-service";
import {SelectionUtils} from "../../../selection-utils";
import {MatIcon} from "@angular/material/icon";

import {ReactiveFormsModule} from "@angular/forms";

@Component({
    selector: 'app-vertical-sm-com-chassis-options',
    imports: [
    MatIcon,
    ReactiveFormsModule
],
    templateUrl: './vertical-sm-com-chassis-options.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './vertical-sm-com-chassis-options.component.css'
})
export class VerticalSmComChassisOptionsComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  chassisStyleSelection!: GuruEntity;
  shippingSelection!: GuruEntity;
  voltageSelection!: GuruEntity;
  controlsSelection!: GuruEntity;
  autoFlowRegulatorSelection!: GuruEntity;
  waterCircuitSelection!: GuruEntity;
  heatExchangerOptionsSelection!: GuruEntity;
  chassisInsulationOptionsSelection!: GuruEntity;
  blowerMotorSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.CHASSIS_OPTIONS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.chassisStyleSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCHSStyle');
    this.shippingSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USShipping');
    this.voltageSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCHSVoltage');
    this.controlsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCHSControlOptions');
    this.autoFlowRegulatorSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USFlowCntl');
    this.waterCircuitSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USWaterCircuitOptions');
    this.heatExchangerOptionsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USHeatExchangerOptions');
    this.chassisInsulationOptionsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCHSInsulationOptions');
    this.blowerMotorSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USBlowerMotor');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
